// 9fbef606107a605d69c0edbcd8029e5d 
const STATIC_PAGE_CONSTANTS = {
  STATIC_PAGE_PREFIX: 'content/',
};
export default STATIC_PAGE_CONSTANTS;
